module.exports = __webpack_public_path__ + "static/media/layout-record.bcdff65e.svg";